import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VRow,{staticClass:"appBar",attrs:{"no-gutters":"","role":"banner","aria-label":"Logo przekierowujące do strony głównej Słupskiej Karty Mieszkańca"}},[_c('logo')],1)}
var staticRenderFns = []

export { render, staticRenderFns }